import * as React from 'react'
import './index.css'
import Chip from 'components/Chip'

export default function ChipRectangle (props) {
  return (
    <Chip
      className='chip-rectangle'
      {...props}
    />
  )
}
